// extracted by mini-css-extract-plugin
module.exports = {"greenFont":"navbarmain_greenFont__1FUva","logo":"navbarmain_logo__FjD5-","navbar":"navbarmain_navbar__2Q-xP","button":"navbarmain_button__2gye3"};